app
    .controller('ChatController', function ChatController($http, ChatService, $scope, $interval, $uibModal, loginService) {
        let currentRoom;
        this.ChatService = ChatService;
        this.timers = {};
        this.intervals = {};
        this.hideCamera = false;
        this.muted = false;

        const reset = () => {
            this.currentMessage = "";
            this.isVideo = false;
            this.hideChat = false;
            this.muted = false;
            this.hideCamera = false;
        };

        this.send = () => {
            ChatService.sendMessage(this.currentMessage);
            this.currentMessage = "";
            // Here check if is not invited then message send as notification.
            if (!ChatService.isConnected && ChatService.receiver && ChatService.receiver.roles.includes('ROLE_COACH')) {
                ChatService.sendNotification(ChatService.receiver._id);
            }
        };

        this.isAuthor = (message) => {
            return ChatService.sender._id === message.author;
        };

        this.isStripeConnected = () => {
            return loginService.currentUser.isStripeConnected;
        };

        this.addExpiryTimer = (message) => {
            const expiresAt = +message.body.expiresAt;
            const dur = (new Date(expiresAt) - new Date()) / 1000;
            this.timers[message.id] = new Date("1970-01-01 01:00:00");
            const timer = this.timers[message.id];

            timer.setSeconds(dur);
            if (!this.intervals[message.id]) {
                this.intervals[message.id] = $interval(() => {
                    if (expiresAt < Date.now()) {
                        $interval.cancel(this.intervals[message.id]);
                    } else {
                        timer.setSeconds(timer.getSeconds() - 1);
                    }
                }, 1000);
            }
        };

        this.isExpired = (message) => {
            const expiresAt = +message.body.expiresAt;

            if (!this.timers[message.id] && expiresAt > Date.now()) {
                this.addExpiryTimer(message);
            }

            return message.isExpired || expiresAt < Date.now();
        };

        this.sendLiveInvitation = (service) => {
            // 2 minutes
            const expiresAt = Date.now() + (10 * 60 * 1000);
            if(service){
                this.internalMessage({
                    type: 'INVITATION',
                    serviceId: service.id,
                    price: service.price,
                    bundledHours: service.bundledHours,
                    expiresAt
                });
            } else {
                this.internalMessage({
                    type: 'INVITATION_REMAINING',
                    expiresAt
                });
            }

        };

        this.initiate = () => {
            $uibModal
                .open({
                    component: 'coachLiveAgreement',
                    animation: false,
                    resolve: {
                        client: function () {
                            return ChatService.receiver;
                        },
                        coach: function () {
                            return ChatService.sender;
                        },
                    }
                })
                .result
                .then((service) => {
                    this.sendLiveInvitation(service);
                }, () => {

                })
                .catch(() => {

                });
        };

        this.setElapsed = () => {
            const now = Date.now();
            const start = +new Date(this.startTime);
            const duration = now - start;
            const d = new Date("1-1-1970 00:00:00");
            d.setSeconds(duration / 1000);
            this.elapsedTime = d;
        };

        this.joinCall = (message) => {
            if (this.video) {
                return;
            }
            this.isVideo = true;
            this.toggleChat();
            ChatService
                .initVideo(message.body.roomName)
                .then(({room, roomObject}) => {
                    this.startTime = new Date(`${roomObject.dateCreated.date} ${roomObject.dateCreated.timezone}`);
                    this.setElapsed();
                    this.intervals.callDuration = $interval(() => {
                        this.setElapsed();
                    }, 1000);
                    if (!room) {
                        return;
                    }
                    currentRoom = room;
                    currentRoom.participants.forEach(onNewParticipant);
                    currentRoom.on('participantConnected', onNewParticipant);
                    currentRoom.on('disconnected', () => {
                        currentRoom.localParticipant.tracks.forEach(publication => {
                            this.isVideo = false;
                            this.hideChat = false;
                            // TODO: Do it angular way
                            document.getElementById('remote-media').innerHTML = "";
                            document.getElementById('local-media').innerHTML = "";
                            const attachedElements = publication.track.detach();
                            attachedElements.forEach(element => element.remove());
                        });
                    });

                    currentRoom.localParticipant.tracks.forEach(publication => {
                        const localMediaContainer = document.getElementById('local-media');
                        localMediaContainer.appendChild(publication.track.attach());
                    });

                })
                .catch(() => {
                    this.isVideo = false;
                    this.hideChat = false;
                    alert('Unable to join. Session has ended');
                });
        };

        const onNewParticipant = (participant) => {
            participant.tracks.forEach(publication => {
                if (publication.isSubscribed) {
                    const track = publication.track;
                    document.getElementById('remote-media').appendChild(track.attach());
                }
            });

            participant.on('trackSubscribed', track => {
                document.getElementById('remote-media').appendChild(track.attach());
            });
        };

        this.onClose = () => {
            ChatService.closeChat();
            reset();
        };

        this.$onInit = () => {
            reset();
        };

        this.isHost = (user) => {
            return currentRoom.name.includes(user._id);
        };

        this.isCoach = () => {
            return ChatService.sender.roles.includes('ROLE_COACH');
        };

        this.findCoach = () => {
            return [ChatService.sender, ChatService.receiver].find((user) => !this.isHost(user));
        };

        this.findClient = () => {
            return [ChatService.sender, ChatService.receiver].find((user) => this.isHost(user));
        };

        this.endVideoCall = () => {
            if (!currentRoom) {
                return;
            }
            currentRoom.disconnect();
            $interval.cancel(this.intervals.callDuration);
            const quotedMessage = ChatService.messages.find((message) => message.type === 'INTERNAL' && message.body.type === 'INVITATION_ACCEPTED' && message.body.roomName === currentRoom.name);
            this.internalMessage({
                quotes: quotedMessage.id,
                type: 'LIVE_SESSION_ENDED'
            });
            ChatService.deleteRoom(currentRoom.sid, this.findCoach()._id, this.findClient()._id);
        };

        this.toggleMic = () => {
            currentRoom.localParticipant.audioTracks.forEach((publication) => {
                if (this.muted) {
                    publication.track.enable();
                } else {
                    publication.track.disable();
                }
            });
            this.muted = !this.muted;
        };

        this.toggleCamera = () => {
            currentRoom.localParticipant.videoTracks.forEach((publication) => {
                if (this.hideCamera) {
                    publication.track.enable();
                } else {
                    publication.track.disable();
                }
            });
            this.hideCamera = !this.hideCamera;
        };

        this.toggleChat = () => {
            this.hideChat = !this.hideChat;
        };

        this.accept = (message) => {
            if(!message.body.serviceId){
                return this.crRoom(message);
            }
            $uibModal
                .open({
                    component: 'clientLiveAgreement',
                    animation: false,
                    resolve: {
                        client: function () {
                            return ChatService.sender;
                        },
                        coach: function () {
                            return ChatService.receiver;
                        },
                        service: function () {
                            return {
                                id: message.body.serviceId,
                                price: message.body.price,
                                bundledHours: message.body.bundledHours,
                                bundlePrice: message.body.price * message.body.bundledHours,
                            };
                        }
                    }
                })
                .result
                .then((_response) => {
                    this.crRoom(message);
                }, () => {

                })
                .catch(console.error);
        };

        this.crRoom = (message) => {
            ChatService
                .createRoom()
                .then((response) => {
                    const roomName = response.data.uniqueName;
                    this.joinCall({
                        body: {
                            roomName
                        }
                    });
                    this.internalMessage({
                        roomName,
                        quotes: message.id,
                        type: 'INVITATION_ACCEPTED'
                    });
                })
                .catch(console.error);
        };

        this.reject = (message) => {
            const roomName = message.body.roomName;

            this.internalMessage({
                roomName,
                quotes: message.id,
                type: 'INVITATION_REJECTED'
            });
        };

        this.internalMessage = (options) => {
            const url = new URL('msg://studiogym.com');

            angular.forEach(options, (value, key) => {
                url.searchParams.set(key, value);
            });

            ChatService.sendMessage(url.toString());
        };

        this.parseBody = (message) => {
            return paramsToObject(new URL(message.body).searchParams.entries());
        };

        this.showInvite = (type) => {
            if (type === 'AS_COACH') {
                return !this.isCoach() && ChatService.isConnected === false;
            } else if ('AS_CLIENT') {
                return this.isCoach() && ChatService.isConnected === false;
            }
        };

        this.invite = () => {
            $uibModal
                .open({
                    component: 'coach-invite',
                    windowClass: 'coach-invite-modal',
                    animation: false,
                    size: 'lg',
                    resolve: {
                        coach: function () {
                            return ChatService.receiver;
                        }
                    }
                })
                .result
                .then(() => {
                    this.invited = true;
                }, () => {
                    console.log('error inviting coach');
                })
                .catch(() => {
                    console.log('error');
                });
        };

        function paramsToObject(entries) {
            let result = {};
            for (let entry of entries) { // each 'entry' is a [key, value] tupple
                const [key, value] = entry;
                result[key] = value;
            }
            return result;
        }
    })
    .directive('isTyping', function (ChatService) {
        return function (scope, element, attrs) {
            element.bind("keydown keypress", function (event) {
                if (event.which !== 13) {
                    ChatService.notifyTyping();
                }
            });
        };
    })
    .component('chatWindow', {
        template: `
    <div class="chat" ng-if="$ctrl.ChatService.receiver" ng-class="{'chat-video': $ctrl.isVideo, 'hide-chat': $ctrl.hideChat}">
        <div class="chat-left">
            <div id="remote-media">
            </div>
            <div id="local-media"></div>
            <h1>{{ 'chat.video.waiting' | translate: $ctrl.ChatService.receiver}}</h1>
            <div class="controls">
                <button class="btn btn-invite" ng-click="$ctrl.endVideoCall()">{{ 'chat.video.stop' | translate }}</button>
                <div class="timer">{{ $ctrl.elapsedTime | date : 'HH:mm:ss' }}</div>
                <button class="btn btn-live" ng-click="$ctrl.toggleMic()">
                    <chat-icon type="mic" width="20" height="20" ng-if="!$ctrl.muted"></chat-icon>
                    <chat-icon type="mic-off" width="20" height="20" ng-if="$ctrl.muted"></chat-icon>
                </button>
                <button class="btn btn-live" ng-click="$ctrl.toggleCamera()">
                    <chat-icon type="videocam"  width="20" height="20"  ng-if="!$ctrl.hideCamera"></chat-icon>
                    <chat-icon type="videocam-off"  width="20" height="20"  ng-if="$ctrl.hideCamera"></chat-icon>
                </button>
            </div>
        </div>
        <div class="chat-right">
            <div class="title-bar">
                <div>
                    <div class="heading">
                        <chat-icon width="15" height="15" type="message" ng-click="$ctrl.toggleChat()"></chat-icon>
                        <span    ng-click="$ctrl.toggleChat()">{{$ctrl.ChatService.receiver.firstName}} {{$ctrl.ChatService.receiver.lastName}}</span>
                        <span>{{$ctrl.ChatService.isTyping ? ('chat.text.typing' | translate ) : ''}}</span>
                    </div>
                </div>
                <div >
                    <span ng-click="$ctrl.toggleChat()">
                        <chat-icon width="15" height="15" type="dash"></chat-icon>
                    </span>
                    <span ng-click="$ctrl.onClose()" ng-if="!$ctrl.isVideo" style="margin-left: 15px;">
                        <chat-icon width="15" height="15" type="cross"></chat-icon>
                    </span>
                </div>
            </div>
            <div class="action-bar" ng-if="$ctrl.showInvite('AS_COACH') || $ctrl.showInvite('AS_CLIENT')"> <!--  || $ctrl.isCoach() -->
                <button class="btn btn-sm btn-invite"
                    ng-if="$ctrl.showInvite('AS_COACH')"
                    ng-click="$ctrl.invite()"
                >
                    <chat-icon width="15" height="15" type="pen"></chat-icon>
                    {{ 'chat.text.invite.coach' | translate }}
                </button>
                <button class="btn btn-sm btn-invite" ng-if="$ctrl.showInvite('AS_CLIENT')">
                    <chat-icon width="15" height="15" type="pen"></chat-icon>
                    {{ 'chat.text.invite.client' | translate }}
                </button>
                <!-- <button class="btn btn-sm btn-live" ng-if="$ctrl.isCoach() && $ctrl.isStripeConnected()" ng-click="$ctrl.initiate()">
                    <chat-icon width="15" height="15" type="video"></chat-icon>
                    {{ 'chat.text.invite.liveWorkout' | translate }}
                </button> -->
            </div>
            <div class="messages" scroll-bottom="$ctrl.ChatService.messages">
                <div class="message-container" ng-repeat="message in $ctrl.ChatService.messages" ng-class="{own:  $ctrl.ChatService.sender._id === message.author, 'is-invitation': message.type === 'INTERNAL'}">
                    <div class="avatar">
                        <img ng-src="{{ message.author | chatUser : 'picture' }}" alt="">
                    </div>
                    <div class="body">
                        <div class="message" ng-switch="message.type">
                            <span ng-switch-when="TEXT">
                                <pre>{{message.body}}</pre>
                            </span>
                            <div  ng-switch-when="INTERNAL" class="invitation-bubble" ng-switch="message.body.type">
                                <div ng-switch-when="INVITATION">
                                    <div class="header">
                                        <span>
                                            <chat-icon width="15" height="15" type="video"></chat-icon>
                                            {{ 'chat.text.invitation.live.request.header' | translate }}
                                        </span>
                                        <span>{{ '$'+ message.body.price + '/hr'}}</span>
                                    </div>
                                    <div class="body">
                                        <div class="title">{{ 'chat.text.invitation.live.request.title' | translate }}</div>
                                        <div ng-if="!$ctrl.isExpired(message)">
                                            <div ng-if="$ctrl.isAuthor(message)">{{ 'chat.text.invitation.live.request.waitingForApproval' | translate }}</div>
                                            <div ng-if="!$ctrl.isAuthor(message)">
                                                <button ng-click="$ctrl.accept(message)" class="btn btn-accept btn-sm">{{ 'chat.text.invitation.live.request.accept' | translate }}</button>
                                                <button ng-click="$ctrl.reject(message)" class="btn btn-reject btn-sm">{{ 'chat.text.invitation.live.request.reject' | translate }}</button>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="footer" ng-hide="$ctrl.isExpired(message)">
                                        <span>{{ 'chat.text.invitation.live.request.expiresIn' | translate }}</span>
                                        <span>{{$ctrl.timers[message.id] | date : 'mm:ss'}}</span>
                                    </div>
                                    <div class="footer center" ng-show="$ctrl.isExpired(message)">
                                        <span>{{ 'chat.text.invitation.live.request.footer' | translate }}</span>
                                    </div>
                                </div>
                                <div ng-switch-when="INVITATION_REMAINING">
                                    <div class="header">
                                        <span>
                                            <chat-icon width="15" height="15" type="video"></chat-icon>
                                            {{ 'chat.text.invitation.live.request.header' | translate }}
                                        </span>
                                    </div>
                                    <div class="body">
                                        <div class="title">{{ 'chat.text.invitation.live.request.title' | translate }}</div>
                                        <div ng-if="!$ctrl.isExpired(message)">
                                            <div ng-if="$ctrl.isAuthor(message)">{{ 'chat.text.invitation.live.request.waitingForApproval' | translate }}</div>
                                            <div ng-if="!$ctrl.isAuthor(message)">
                                                <button ng-click="$ctrl.accept(message)" class="btn btn-accept btn-sm">{{ 'chat.text.invitation.live.request.accept' | translate }}</button>
                                                <button ng-click="$ctrl.reject(message)" class="btn btn-reject btn-sm">{{ 'chat.text.invitation.live.request.reject' | translate }}</button>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="footer" ng-hide="$ctrl.isExpired(message)">
                                        <span>{{ 'chat.text.invitation.live.request.expiresIn' | translate }}</span>
                                        <span>{{$ctrl.timers[message.id] | date : 'mm:ss'}}</span>
                                    </div>
                                    <div class="footer center" ng-show="$ctrl.isExpired(message)">
                                        <span>{{ 'chat.text.invitation.live.request.footer' | translate }}</span>
                                    </div>
                                </div>
                                <div ng-switch-when="INVITATION_ACCEPTED">
                                    <div class="header">
                                        <span>
                                            <chat-icon width="15" height="15" type="video"></chat-icon>
                                            {{ 'chat.text.invitation.live.accepted.header' | translate }}
                                        </span>
                                    </div>
                                    <div class="body" >
                                        <button class="btn"
                                                ng-show="!message.isExpired"
                                                ng-click="$ctrl.joinCall(message)"
                                                ng-class="{'btn-reject': $ctrl.isAuthor(message),'btn-accept': !$ctrl.isAuthor(message)}">
                                            {{ 'chat.text.invitation.live.accepted.body' | translate }}
                                        </button>
                                        <div class="title" ng-show="message.isExpired">
                                            {{ 'chat.text.invitation.live.accepted.body' | translate }}
                                        </div>
                                    </div>
                                    <div class="footer center" ng-show="message.isExpired">
                                        <span>{{ 'chat.text.invitation.live.accepted.footer' | translate }}</span>
                                    </div>
                                </div>
                                <div ng-switch-when="INVITATION_REJECTED">
                                    <div class="header">
                                        <span>
                                            <chat-icon width="15" height="15" type="video"></chat-icon>
                                            {{ 'chat.text.invitation.live.rejected.header' | translate }}
                                        </span>
                                    </div>
                                    <div class="body">
                                        {{ 'chat.text.invitation.live.rejected.footer' | translate }}
                                    </div>
                                </div>
                                <div ng-switch-when="LIVE_SESSION_ENDED">
                                    <div class="header">
                                        <span>
                                            <chat-icon width="15" height="15" type="video"></chat-icon>
                                            {{ 'chat.text.invitation.live.ended.header' | translate }}
                                        </span>
                                    </div>
                                    <div class="body">
                                        {{ 'chat.text.invitation.live.ended.body' | translate }}
                                    </div>
                                </div>
                                <div ng-switch-default><i>{{ 'chat.text.unsupported' | translate }}</i></div>
                            </div>
                        </div>
                        <div class="info">
                            <span class="name">
                                {{ message.author | chatUser : 'firstName' }}
                            </span> •
                            <span class="date">
                                {{ message.timestamp | date : 'MMM d' }}
                            </span>
                            <span class="time">
                                {{ message.timestamp | date : 'h:mm a' }}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="send" style="width: 100%;border-top: 1px solid #000;">
                <form name="form" ng-submit="form.$valid && $ctrl.send()">
                    <div class="input-group">
                        <textarea class="form-control"
                        placeholder="Send a Message"
                        style="height: 48px" ng-model="$ctrl.currentMessage"
                        sg-enter="form.$valid && $ctrl.send()"
                        is-typing
                        required></textarea>
                        <button class="btn btn-live" type="submit">
                            {{ 'chat.text.send' | translate}}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    </div>
    `,
        controller: "ChatController"
    });
